import React from 'react';

import i18n from 'i18next';

import { Typo } from 'uikit/content';

import styles from '../styles/betaLabel.module.scss';

const BetaLabel = () => (
  <Typo className={styles.element} modifier="uppercase" variant="s01">
    {i18n.t('beta')}
  </Typo>
);

export default React.memo(BetaLabel);
